const strings = {
  NAO_FOI_POSSIVEL_PROCESSAR_ESTA_REQUISICAO:
    'Não foi possível processar esta requisição',
  OCORREU_UM_ERRO_AO_TENTAR_PROCESSAR_ESSA_REQUISICAO:
    'Ocorreu um erro ao tentar processar essa requisição',
  NAO_HA_NENHUM_REGISTRO_PARA_REALIZAR_A_EXPORTACAO:
    'Não há nenhum registro para realizar a exportação',
  CAMPO_OBRIGATORIO: 'Campo obrigatório',
  O_LIMITE_MAXIMO_PARA_ESSA_EXPORTACAO_E_DE_ATE_1000_REGISTROS:
    'O limite máximo para essa exportação é de até 1000 registros',
  O_TAMANHO_DO_ARQUIVO_EXCEDE_O_LIMITE_DE_128_MB:
    'O tamanho do arquivo excede o limite de 128 MB',
  O_TAMANHO_DO_ARQUIVO_ULTRAPASSA_O_LIMITE_DE_25_MB_ESTABELECIDO_PELO_GMAIL:
    'O tamanho do arquivo ultrapassa o limite de 25 MB estabelecido pelo Gmail',
  NAO_E_POSSIVEL_REALIZAR_ACAO_NC_VINCULADA_FECHADA:
    'Não é possível realizar a ação porque há uma NC vinculada com status encerrado',
  INFORME_UM_TELEFONE_VALIDO: 'Informe um telefone válido',
  O_VALOR_TOTAL_ITENS_NÃO_PODE_SER_DIFERENTE_DA_SOMA_TOTAL_DOS_ITENS_POR_SETOR:
    'O valor da quantidade total de itens não pode ser diferente da soma dos itens distribuídos por setor',
  INFORME_UM_VALOR_VALIDO: 'Informe um valor válido',
  TIPO_DE_ARQUIVO_NAO_SUPORTADO: 'Tipo de arquivo não suportado',
  A_SUBMISSAO_DE_UM_ARQUIVO_E_OBRIGATORIA:
    'A submissão de um arquivo é obrigatória',
  NENHUM_ARQUIVO_SELECIONADO: 'Nenhum arquivo selecionado',
  O_VALOR_TOTAL_ITENS_NÃO_PODE_SER_DIFERENTE_DA_SOMA_TOTAL_DOS_ITENS_POR_SETOR:
    'O valor da quantidade total de itens não pode ser diferente da soma dos itens distribuídos por setor',
  INFORME_UM_VALOR_VALIDO: 'Informe um valor válido',
  SENHA_ATUAL_INVALIDA: 'A senha atual é inválida',
  CONFIRMACAO_DIFERENTE_DA_SENHA_CRIADA:
    'A confirmação está diferente da senha criada',
  SENHA_NAO_ATENDE_REQUISITOS_MINIMOS:
    'A nova senha não atende aos requisitos mínimos',
  NOVA_SENHA_IGUAL_A_ATUAL: 'A nova senha não pode ser igual a atual',
  SENHA_ALTERADA_SUCESSO: 'Senha alterada com sucesso!',
  SENHA_REDEFINIDA_SUCESSO: 'Senha redefinida com sucesso!',
  O_CAMPO_NAO_PODE_CONTER_APENAS_ESPACOS:
    'O campo não pode conter apenas espaços',
  NAO_E_POSSIVEL_REALIZAR_ACAO_POIS_DOCUMENTO_JA_POSSUI_VINCULO_COM_OUTRA_NC:
    'Não é possível realizar a ação pois o documento já possui vínculo com outra NC',
  O_CODIGO_DEVE_CONTER_0_DIGITOS: (dig) =>
    `O código deve conter ${dig} dígitos`,
};

export default strings;
